import PointAndClick from './PointAndClick.js';

import { Colors } from '../../consts/Colors.js';
import FONTS from '../../consts/Fonts.js';
import ButtonRounded from '../../prefabs/global/buttons/ButtonRounded.js';
import PopUpBlue from '../../prefabs/global/popup/PopUpBlue.js';
import DebriefPanel from '../../prefabs/chapitre3/DebriefPanel.js';
import QuestionPanel_1 from '../../prefabs/chapitre3/questions/QuestionPanel_01.js';
import QuestionPanel_2 from '../../prefabs/chapitre3/questions/QuestionPanel_02.js';
import Smartphone from '../../prefabs/chapitre3/smartphone/Smartphone.js';


export default class Chapitre3_1 extends PointAndClick {
    constructor() {
        super({
            key: "Chapitre3_1"
        })
    }

    init(data){
        this.audioName = 'ImmovableMountain';
        super.init(data);   
    }

    create(){
        super.create();

        // Ajout popup d'intro
        this.popupIntro = new PopUpBlue(this, this.width/2, this.height/2, 660, 360)
        this.popupIntro.setAlpha(0);


        let introText = "C'est étrange, cette usine ressemble finalement à un simple entrepôt.\n\nOn dirait que l'entreprise se contente de reconditionner des produits en ajoutant sa propre marque.";
        let popupIntroText = this.add.text(0, 0, introText, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '24px',
            color: Colors.Text.White,
            lineSpacing: 8,
            align: 'left',
            wordWrap: { width: 550 }
        }).setOrigin(0.5, 0);
        this.popupIntro.addElementToBody(popupIntroText, 40);

        let buttonCloseIntro = new ButtonRounded(this, 0, 0,  { 
            text: "Explorer le bâtiment",
            color: Colors.Elmt.White,
            textColor: Colors.Text.Black,
            textHoverColor: Colors.Text.Blue,
            borderColor: Colors.Elmt.White,
            borderHoverColor: Colors.Elmt.Blue,
        });
        this.popupIntro.addButtonToBody(buttonCloseIntro);
        buttonCloseIntro.setClickFunction( () => {
           this.popupIntro.animOut(() => {
                this.popupIntro.destroy(true);
                this.displayButtons();
            });
        })

        this.popupIntro.animIn()
    }


    // -- Popups spécifiques --
    openIndiceSpecial(id, data){
        if(data.type == "slogan"){
            if(this.chapitreProgression.smartphone.locked){
                this.openIndiceSlogan(id, data);
            }else{
                this.openSmartphone();
            }
        }
    }

    openIndiceSlogan(id, data){
        this.openIndice(id);
        this.popup.textElmt.setAlign("left")

        this.popup.closeButton.x = -154

        // Ajout bouton rentrer dans l'usine
        let closeButton = new ButtonRounded(this, 85, this.popup.background.height / 2 - 8, { 
            text: "Démarrer l'enquête",
            color: Colors.Elmt.Orange,
            hoverColor: Colors.Elmt.Blue,
            borderHoverColor: Colors.Elmt.LightBlue,
            borderColor: Colors.Elmt.LightOrange,
        });
        closeButton.setClickFunction( () => {
            this.closePopup()
            this.time.addEvent({
                delay: 500,
                callback: () => {
                    this.chapitreProgression.smartphone.locked = false;
                    this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
                    this.openSmartphone();
                }
            })
        } )
        this.popup.add(closeButton);
    }

    openSmartphone(){
        if(this.ordi)
            return

        // this.blurBackground();
        this.hideButtons();

        // On zoom sur le fond
        this.tweens.add({
            targets: this.background,
            scale: 1.88,
            x:-820,
            y:-822,
            duration: 300,
        })

        // Ajout ordinateur
        this.ordi = new Smartphone(this, 1518, 25)
        this.ordi.setAlpha(0)

        this.ordi.animIn(() => {
            // Change la musique
            this.soundManager.playAudio('DangerAhead')

            // Affiche le panneau de question
            this.addQuestionPanel();
        })
    }

    closePopup(){
        super.closePopup();

        // On remet le fond à sa place
        this.tweens.add({
            targets: this.background,
            scale: 1,
            x:0,
            y:0,
            duration: 100,
        })
    }

    addQuestionPanel(){
        const num = this.chapitreProgression.smartphone.question
        switch(num){
            case 1:
                this.addQuestionPanel1()
                break;
            case 2:
                this.addQuestionPanel2()
                break;
        }
    }

    // Panneau de question qui s'ouvre une fois l'enquete débutée
    addQuestionPanel1(){
        this.chapitreProgression.smartphone.question = 1;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
        this.questionPanel = new QuestionPanel_1(this, 0, 0, {config: this.config.questions[0], totQuestion: this.config.questions.length})
        this.questionPanel.depth = 999
        this.questionPanel.animIn();
    }

    addQuestionPanel2(){
        this.chapitreProgression.smartphone.question = 2;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
        this.questionPanel = new QuestionPanel_2(this, 0, 0, {config: this.config.questions[1], totQuestion: this.config.questions.length})
        this.questionPanel.depth = 999
        this.questionPanel.animIn();
    }

    addDebrief(){
        this.ordi.lockButtons(); 
        
        this.debrief = new DebriefPanel(this)
        this.debrief.depth = 100
        this.debrief.animIn();
    }

    closeDebrief(){
        this.debrief.destroy(true);

        this.closePopup()
        this.time.addEvent({
            delay: 500,
            callback: () => {
                let txt = 'Kensei Therapeutics utilise l’image de Leïla pour sa communication… et diffuse de fausses citations en son nom.\n\nLeur usine dernier cri n’est en réalité qu’un simple entrepôt de stockage et de réemballage. Tout cela ressemble à un commerce bien rodé, qui profite de la notoriété de Leïla pour vendre des produits inefficaces.\n\nMais quelque chose ne colle pas. Pourquoi aurait-elle accepté ça ?\n\nIl n’y a aucune trace d’elle ici. Je ferais mieux de me rendre à Tokyo, dans les bureaux de l’entreprise… Peut-être y trouverai-je enfin sa piste ?'
                this.popupFinChapitre(txt, 770, "DebutChapitre4");
            }
        })
    }

    closePanelQuestion(endFunc){
        if(this.questionPanel == null || this.questionPanel == undefined) return;

        // Ferme le panneau de question
        this.questionPanel.animOut(() => {
            this.questionPanel.destroy(true);
            this.questionPanel = null;

            if(endFunc)
                endFunc(this);
        })
    }
}